const formatter = new Intl.DateTimeFormat('ru', {
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
});

const parseDate = date => (date ? formatter.format(new Date(date)) : '');

export default parseDate;
